// extracted by mini-css-extract-plugin
module.exports = {"simpleAreaContainer":"SimpleArea_simpleAreaContainer__r0iKv"};